export default __webpack_public_path__ + "static/media/house-manager.e882f438.svg";